import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PATTERN } from 'src/app/constants/pattern';
import { ALERT_ERRORS, CDC_VALIDATIONS } from 'src/app/core/constants/Errors';
import { DOC_TYPES_CDC } from 'src/app/core/constants/FormLists';
import { Payment, Transaction } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { CustomerCreditService } from './services/customer-credit.service';
import { AUTOCOMPLETE_METHOD_PAY_TYPES, CONSUMER_CREDIT, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CustomerValidationRequest } from 'src/app/models/customerValidationRequest';
import { CustomerValidationResponse } from 'src/app/models/customerValidationResponse';
import { AuthService } from 'src/app/services/auth.service';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
interface InfoOrderCheckout {
    orderID: string;
    paymentsLength: number;
}

@Component({
    selector: 'app-consumer-credit',
    templateUrl: './consumer-credit.component.html',
    styleUrls: ['./consumer-credit.component.scss'],
})
export class ConsumerCreditComponent implements OnInit {
    @Input() information: Payment;
    @Input() transaction: Transaction;
    @Input() infoOrderCheckout: InfoOrderCheckout;
    @Output() CDC = new EventEmitter();

    loading = false;
    formPrivacyValid = false;
    isEditableInfo = false;
    readOnly = false;
    validAmount = false;
    form: FormGroup;
    errorsMessages = CDC_VALIDATIONS;
    listOfDocuments = DOC_TYPES_CDC;
    responseCodes = CONSUMER_CREDIT.RESPONSE_CODES;
    responseMessages = CONSUMER_CREDIT.RESPONSE_MESSAGES;
    template = '';
    alertButtonMsg = '¡Reintentar!';
    buttonMessage = 'Consultar';
    infoMessage = 'bancolombia-Bnpl-redirect';
    objectControlData = [
        {
            formControl: 'titularsName',
            readOnly: false,
        },
        {
            formControl: 'documenType',
            readOnly: false,
        },
        {
            formControl: 'documentNumber',
            readOnly: false,
        },
    ];
    orderID: string;

    private parameter = 'fixAutocompleteTokenPersonalInfoFF';
    private flag = 'fixAutocompleteTokenPersonalInfoFF';
    private platform = 'payvalida';
    fixAutocompleteTokenPersonalInfoFF: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private tokenService: TokenServiceService,
        private alertService: AlertService,
        private customerService: CustomerCreditService,
        private authService: AuthService,
        private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
        private featureFlagService: PayvalidaFeatureFlagService
    ) {
        this.form = this.formBuilder.group({
            titularsName: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(255), Validators.pattern(PATTERN.CHARACTERS_SPACE_CHARACTERS)])],
            documenType: ['', Validators.required],
            documentNumber: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(15), Validators.pattern(PATTERN.REGEX_WITHOUT_SPACES)])],
        });
    }

    ngOnInit(): void {
        this.orderID = this.authService.getOrderID();
        this.template = this.information.template;
        this.validateAmount();
        this.disabledAndPatchItems();
    }
    /**
     * @description {changeMethod} Function that returns to payment methods
     */
    changeMethod() {
        this.CDC.emit();
    }
    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate(valid: boolean) {
        this.formPrivacyValid = valid;
    }
    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms(): boolean {
        return this.form.valid && this.formPrivacyValid;
    }
    /**
     * @description {customersLoanValidation} Function that performs the validation of the client's loan
     */
    customersLoanValidation() {
        this.loading = true;
        const checkoutToken = this.tokenService.getToken();
        let requestBody: CustomerValidationRequest = {
            token: checkoutToken,
            document: this.form.get('documentNumber').value,
            document_type: this.form.get('documenType').value,
            agree_terms_conditions: this.formPrivacyValid,
        };
        this.customerService
            .bancolombiaCustomerValidation(requestBody)
            .pipe(finalize(() => (this.loading = false)))
            .subscribe({
                next: (response: CustomerValidationResponse) => {
                    this.buildConsumersCreditResponse(response);
                },
                error: (_) => this.alertService.showPopup(ALERT_ERRORS.SORRY_ALERT, this.responseMessages.STANDARD_ERROR_MESSAGE, ALERT_ERRORS.TYPE_WARNING, GENERAL_CONSTANTS.OK_DEFAULT_STRING)
            });
    }
    /**
     *
     * @description {buildCdcResponse} Function to build data response service
     * @param responseCode
     */
    buildConsumersCreditResponse(response: CustomerValidationResponse) {
        
        switch (response.CODE) {
            case GENERAL_CONSTANTS.OK_RESPONSE_CODE:
                this.redirectCustomerCredit(response);
                break;
            case this.responseCodes.INELEGIBLE_CLIENT:
                this.alertService.showPopup(ALERT_ERRORS.SORRY_ALERT, this.responseMessages.QUOTE_NOT_AVAILABLE, ALERT_ERRORS.TYPE_WARNING, this.alertButtonMsg);
                break;
            case this.responseCodes.AMOUNT_TO_LOW:
                this.alertService.showPopup(ALERT_ERRORS.SORRY_ALERT, this.responseMessages.INVALID_AMOUNT, ALERT_ERRORS.TYPE_WARNING, this.alertButtonMsg);
                break;
            default:
                this.alertService.showPopup(ALERT_ERRORS.SORRY_ALERT, this.responseMessages.STANDARD_ERROR_MESSAGE, ALERT_ERRORS.TYPE_WARNING, GENERAL_CONSTANTS.OK_DEFAULT_STRING);
                break;
        }
    }
    /**
     * @description {redirectCustomerCredit} Function to redirect the flow of consumer credit
     */
    redirectCustomerCredit(response: CustomerValidationResponse) {
        let returnUrl = this.buildCustomerCreditUrl(response);
        if (returnUrl !== '') {
            window.location.href = returnUrl;
            return;
        }
        this.alertService.showAlertProblem();
    }
    /**
     *
     * @description {buildCustomerCreditUrl} Function to build the redirect url to the CDC project
     */
    buildCustomerCreditUrl(response: CustomerValidationResponse) {
        this.loading = true;
        try {
            const newUrl = new URL(environment.redirect_cdc);
            const queryString = newUrl.search;
            const params = new URLSearchParams(queryString);
            params.append('fua_url', response.DATA.fua_url);
            params.append('transaction_id', response.DATA.transaction_id);
            params.append('checkout_token', this.tokenService.getToken());
            params.append('orderID', this.orderID);
            return `${newUrl.origin}${newUrl.pathname}?${params.toString()}`;
        } catch (e) {
            return '';
        }
    }
    /**
     *
     * @description {disabledAndPatchItems} Function to disabled items to checkout form
     */
    disabledAndPatchItems() {
        try {
            let additionalInfo = this.tokenService.exitsAdditionalInformation(this.transaction);
            if (additionalInfo) {
                this.isEditableInfo = this.tokenService.isEditableInfo(additionalInfo);

                this.featureFlagService.getFeatureFlagValue(this.parameter, this.flag, this.platform).subscribe((response: boolean) => {
                    this.fixAutocompleteTokenPersonalInfoFF = response;

                    if (this.fixAutocompleteTokenPersonalInfoFF) {
                        return this.patchValAdditionalInfoService.patchValAdditionalInfo(
                            this.isEditableInfo,
                            additionalInfo,
                            this.form,
                            AUTOCOMPLETE_METHOD_PAY_TYPES.CONSUMER_CREDIT,
                            this.objectControlData
                        );
                    }

                    this.patchValAdditionalInfo(this.isEditableInfo, additionalInfo);
                    return;
                });
            }
            this.patchValueFormsFromToken();
        } catch (error) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }
    /**
     * @description {patchValAdditionalInfo} Function to map the values of the TC form with the additional information of the token
     */
    patchValAdditionalInfo(isEditableInfo: boolean, additionalInformation: any) {
        this.readOnly = isEditableInfo ? false : true;
        const { client } = additionalInformation;
        const { personal_information } = client;

        let lastName = personal_information.lastname ? `${personal_information.lastname}` : '';

        if (personal_information.firstname) {
            this.form.get('titularsName').setValue(`${personal_information.firstname} ${lastName}`);
            this.setReadOnly(this.readOnly, 'titularsName');
        }

        if (personal_information.document.type) {
            this.form.get('documenType').setValue(personal_information.document.type);
            this.setReadOnly(this.readOnly, 'documenType');
        }

        if (personal_information.document.id) {
            this.form.get('documentNumber').setValue(personal_information.document.id);
            this.setReadOnly(this.readOnly, 'documentNumber');
        }
    }
    /**
     * @description {patchValueFormsFromToken} Function to map the values of the TC form with the token information
     */
    patchValueFormsFromToken() {
        if (this.transaction.USER_NAME) {
            this.form.get('titularsName').setValue(`${this.transaction.USER_NAME}`);
            this.setReadOnly(this.readOnly, 'titularsName');
        }

        if (this.transaction.USER_DI) {
            this.form.get('documenType').setValue(`${this.transaction.USER_TYPE_DI}`);
            this.setReadOnly(this.readOnly, 'documenType');
        }

        if (this.transaction.USER_TYPE_DI) {
            this.form.get('documentNumber').setValue(`${this.transaction.USER_DI}`);
            this.setReadOnly(this.readOnly, 'documentNumber');
        }
    }
    /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
    isControlReadOnly(controlName: string): boolean {
        const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);
        return readOnlyControl ? readOnlyControl.readOnly : false;
    }
    /**
     *
     * @description {setReadOnly} function to activate readOnly inout form
     * @param isEditableInfo
     * @param controlName
     */
    setReadOnly(isEditableInfo: boolean, controlName: string) {
        this.objectControlData.find((m) => m.formControl === controlName).readOnly = isEditableInfo;
    }
    /**
     *
     * @description {returnValidateAmount} function to validate the minimum amount of consumer credit
     * @returns
     */
    validateAmount() {
        if (parseInt(this.transaction.ORDER_AMOUT) >= environment.min_value_consumer_credit) {
            this.validAmount = true;
        }
    }
}
